import { useTranslation } from 'react-i18next';
import sha1 from 'sha1';

const useEnhancedTranslation = () => {
    const { t, i18n: i18next } = useTranslation();

    return {
        i18next,

        _: (...args) => {
            if ((args.length === 0) || (typeof args[0] === 'undefined')) {
                return t.apply(i18next, args);
            }

            const [value = '', options = {}] = args;
            const key = ((value, options) => {
                const { context } = options;
                if (context !== undefined && context !== null) {
                    value = value + i18next.options.contextSeparator + options.context;
                }
                return sha1(value);
            })(value, options);

            options.defaultValue = value;
            options.interpolation = {
                ...options.interpolation,
                escapeValue: false
            };

            let text = t(key, options);
            if (typeof text !== 'string' || text.length === 0) {
                text = t(key, { ...options, lng: 'en' });
            }

            return text;
        }
    };
};

export default useEnhancedTranslation;
